import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDraggable, useDroppable } from '@dnd-kit/core'

import { id } from './fields'

// Зона раскладки (фильтры / колонки / строки / значения). Поле в зоне — плашка:
// её можно перетащить в другую зону, на место другой плашки или обратно в список полей.
// У разреза воронка: фильтр по значениям, подсвечена, если фильтр стоит.

function Chip({ zone, name, index, label, filterCount, onFilter, onRemove }) {
	const { t } = useTranslation()
	const drag = useDraggable({ id: id('chip', zone, name) })
	// Плашка — ещё и место вставки: брошенное на неё поле встаёт перед ней
	const drop = useDroppable({ id: id('slot', zone, index) })

	const setRef = (node) => {
		drag.setNodeRef(node)
		drop.setNodeRef(node)
	}

	return (
		<span ref={setRef} {...drag.listeners} {...drag.attributes}
			className={`olap-chip ${filterCount > 0 ? 'olap-chip--filtered' : ''} ${drop.isOver ? 'olap-chip--over' : ''}`}
			style={{ opacity: drag.isDragging ? 0.4 : 1 }}>
			<span>{label}</span>
			{onFilter &&
				<i className={`uil uil-filter ${filterCount > 0 ? 'text-primary' : 'text-muted'}`}
					title={filterCount > 0 ? t('olap_filtered', { count: filterCount }) : t('olap_filter_title')}
					onPointerDown={(e) => e.stopPropagation()}
					onClick={() => onFilter(name)}>
					{filterCount > 0 && <small className="ms-1">{filterCount}</small>}
				</i>
			}
			<i className="uil uil-times text-danger"
				title={t('olap_remove')}
				onPointerDown={(e) => e.stopPropagation()}
				onClick={() => onRemove(zone, name)}></i>
		</span>
	)
}

// className — место зоны в шапке сводной таблицы (olap-zone--values / --columns / --rows / --filters)
function Zone({ zone, title, icon, fields, label, filterCounts, onFilter, onRemove, hint, className = '' }) {
	const { isOver, setNodeRef } = useDroppable({ id: id('zone', zone) })

	return (
		<div ref={setNodeRef} className={`olap-zone ${className} ${isOver ? 'olap-zone--over' : ''}`} title={title}>
			{icon &&
				<div className="olap-zone__title">
					<i className={`uil ${icon} me-1`}></i>{title}
				</div>
			}
			<div className="olap-zone__chips">
				{fields.map((name, index) => (
					<Chip key={name}
						zone={zone}
						name={name}
						index={index}
						label={label(name)}
						filterCount={filterCounts ? (filterCounts[name] || 0) : 0}
						onFilter={onFilter}
						onRemove={onRemove} />
				))}
				{fields.length === 0 &&
					<span className="olap-zone__hint">{hint}</span>
				}
			</div>
		</div>
	)
}

export default Zone
